import { render, staticRenderFns } from "./PollingSession.vue?vue&type=template&id=24860fa8&scoped=true&"
import script from "./PollingSession.vue?vue&type=script&lang=js&"
export * from "./PollingSession.vue?vue&type=script&lang=js&"
import style0 from "./PollingSession.vue?vue&type=style&index=0&id=24860fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24860fa8",
  null
  
)

export default component.exports